module.exports = __webpack_public_path__ + "static/media/fr.bf4cae9b.svg";